// Compare calendar dates so eligibility changes on the client's 50th birthday.
export function isUnderSourcingAge(client, today = new Date()) {
	const value = client?.dateOfBirth;
	if (!value) return false;
	const parts = String(value).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
	const iso = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
	if (!parts && !iso) return false;
	const [year, month, day] = parts ? [+parts[3], +parts[2], +parts[1]] : [+iso[1], +iso[2], +iso[3]];
	let age = today.getFullYear() - year;
	if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) age--;
	return age < 50;
}

export function getSourcingAgeWarning(client, association) {
	if (![client, association].some((item) => isUnderSourcingAge(item))) return '';
	if (!association) return 'Sourcing is only available for clients aged 50 or over.';
	if ([client, association].every((item) => isUnderSourcingAge(item))) return 'Both clients are under 50. Sourcing is only available for clients aged 50 or over.';
	return 'Only the client aged 50 or over will be included in sourcing.';
}